import { render, staticRenderFns } from "./LabelToolEmbed.vue?vue&type=template&id=dec6b7e2&scoped=true"
import script from "./LabelToolEmbed.vue?vue&type=script&lang=js"
export * from "./LabelToolEmbed.vue?vue&type=script&lang=js"
import style0 from "./LabelToolEmbed.vue?vue&type=style&index=0&id=dec6b7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec6b7e2",
  null
  
)

export default component.exports